import { render, staticRenderFns } from "./tableToday.vue?vue&type=template&id=0885cbcf&scoped=true"
import script from "./tableToday.vue?vue&type=script&lang=js"
export * from "./tableToday.vue?vue&type=script&lang=js"
import style0 from "./tableToday.vue?vue&type=style&index=0&id=0885cbcf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0885cbcf",
  null
  
)

export default component.exports